/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useRef, useState} from 'react';
import {GetServerSidePropsContext} from 'next';
import {getPageData} from '../../[[...slug]]/index.page';
import {useDispatch, useSelector} from 'react-redux';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import {handleConvertToLocaleContentful} from '~/utils';

import {
  addMerChandiseData,
  setDataFilter,
  setEndCursor,
  setFilterItem,
  setFilterPrice,
  setMerChandiseData,
  setSortBy,
  setSortItem,
  setTabSelect,
  setEndFeatured,
} from '~/redux-toolkit/merchandiseSlice';

import productsApi from '~/pages/api/services/products-api';
import {usePageSetting} from '~/providers/page-context.provider';
import {ListingType} from '@wearesection/bandai-react-components/molecules/FilterSelectionListing';
import {getGloablByType} from '~/utils/global-operations';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {useRouter} from 'next/router';
import EStoreMerchandiseOrganisms from '~/components/wrapper/organisms/store-merchandise-listing/store-merchandise-listing';
import {handleFormatItemFilter, handleFormatProducts} from '../games/index.page';
import cookie from 'js-cookie';
import {BlockRenderer} from '~/components/renderer/block-renderer';

const Merchandise = (props: any) => {
  const {tabList, seo, filterPrice, sortBy} = props;
  const {locale = '', query} = useRouter();
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const dispatch = useDispatch();

  const tabSelect: number = useSelector(
    (state: any) => state?.merchandise?.tabSelect || tabList?.[0]?.value
  );
  const sortItem: number = useSelector((state: any) => state?.merchandise?.sortItem || 'NEWEST');
  const filterItem: any = useSelector((state: any) => state?.merchandise?.filterItem || {});
  const endCursor: any = useSelector((state: any) => state?.merchandise?.endCursor || '');
  const merchandiseList: any = useSelector((state: any) => state?.merchandise?.productData || []);
  const endFeatured: any = useSelector((state: any) => state?.merchandise?.endFeatured || false);

  const refFirstDispatch = useRef<boolean>(true);
  const refTimeOut = useRef<any>();
  const refTimeOutFirstLoad = useRef<any>();

  // Query first load
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const [isEmptyData, setIsEmptyData] = useState<boolean>(false);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);

  const refCallApi = useRef<any>(true);
  const refPriceMax = useRef<number>(1000);

  const dataFilter: ListingType[] = useSelector(
    (state: any) => state?.merchandise?.dataFilter || []
  );

  const tab = query.tab ?? '';
  const TypeTabFilter: any = {
    title: dataTranslation['estore-products-tab-merchandise'] || '',
    labelPill: dataTranslation['estore-products-tab-sort-filter'] || '',
    tabList: tabList,
    titleSelect: 'all',
  };

  const handleFormatParamBrands = (brands: any[], dataTranslation: any) => {
    return brands.map((item: any) => {
      return {
        title: dataTranslation[item?.keywords] || item?.name,
        name: item?.id,
        isChecked: false,
      };
    });
  };

  // cleanup
  useEffect(() => {
    return () => {
      refCallApi.current = false;
      window.clearTimeout(refTimeOut.current);
    };
  }, []);

  // get data filter content
  useEffect(() => {
    let isCallApi: any = true;
    if (Object.keys(dataTranslation)?.length) {
      const handleGetCommonData = async () => {
        const promises: [ReturnType<typeof productsApi.getBrandsMerchandise>] = [
          productsApi.getBrandsMerchandise(),
        ];
        const [brands] = await Promise.all(promises);

        const itemsBrands = brands?.data?.data || [];
        const lengthBrands = itemsBrands.length;

        const brandList = handleFormatParamBrands(itemsBrands, dataTranslation);
        const currencyCode = JSON.parse(cookie.get('currentValue') || '{"symbol":"S$"}');
        const newPrices = {
          countSelect: 0,
          dataFilter: filterPrice,
          showMore: false,
          title:
            dataTranslation['estore-products-title-filter-price'] +
            `${
              ['tc', 'ko-kr'].includes(`${locale}`.toLowerCase())
                ? ''
                : ` (${currencyCode?.symbol})`
            }`,
          value: 'price',
          type: 'radio',
        };
        const newBrands = {
          countSelect: 0,
          dataFilter: brandList,
          showMore: false,
          title: dataTranslation['estore-filter-brands'],
          value: 'brand',
        };

        const newDataFilter = [];
        if (lengthBrands) {
          newDataFilter.push(newBrands);
        }
        if (
          filterPrice?.length &&
          !['ko-kr', 'tc'].includes(`${locale}`.toLowerCase()) &&
          !['RM', 'Rp', '₱', '฿'].includes(currencyCode?.symbol)
        ) {
          refPriceMax.current = (filterPrice[filterPrice?.length - 2 || 0]?.name || 0) as number;
          newDataFilter.push(newPrices);
        }

        if (newDataFilter?.length && isCallApi) {
          dispatch(setDataFilter(newDataFilter));
        }
      };

      if (!dataFilter?.length && Object.keys(dataTranslation).length) {
        handleGetCommonData();
      }
    }

    return () => {
      isCallApi = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFilter, dataTranslation, filterPrice]);

  //get data filter price
  useEffect(() => {
    if (filterPrice?.length) {
      dispatch(setFilterPrice(filterPrice));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPrice]);

  //set data sort
  useEffect(() => {
    if (sortBy?.length) {
      dispatch(setSortBy(sortBy));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortBy]);

  const handleSetData = (res: any, type?: string) => {
    const {data, meta} = res?.data;
    const {endCursor, hasNextPage} = meta;
    dispatch(setEndCursor(endCursor));
    setHasNextPage(hasNextPage);
    if (meta?.endFeatured) {
      dispatch(setEndFeatured(true));
    }
    const newProducts = handleFormatProducts(data, dataTranslation || {}, locale);
    if (type === 'add') {
      dispatch(addMerChandiseData(newProducts));
    } else {
      dispatch(setMerChandiseData(newProducts));
      if (![...newProducts].length) {
        setIsEmptyData(true);
      }
    }
  };

  // const handleFormatItemFilter = (filter: any) => {
  //   const newFilter = cloneDeep(filter);
  //   if (newFilter?.price) {
  //     const listPrice: any[] = filter?.price ?? [];
  //     const lengthPrice = listPrice.length;
  //     delete newFilter.price;
  //     if (listPrice.includes(refPriceMax.current) && lengthPrice === 1) {
  //       newFilter.price = {minPrice: refPriceMax.current};
  //     } else {
  //       if (lengthPrice === 1) {
  //         newFilter.price = {maxPrice: listPrice[0] || 0};
  //       }
  //       if (lengthPrice > 1) {
  //         newFilter.price = {
  //           minPrice: listPrice[0] || 0,
  //           maxPrice: listPrice[lengthPrice - 1] || 100,
  //         };
  //       }
  //     }
  //   }
  //   if (!newFilter?.platform?.length) {
  //     delete newFilter.platform;
  //   }
  //   if (!newFilter?.genre?.length) {
  //     delete newFilter.genre;
  //   }
  //   return newFilter;
  // };

  // get load more product
  const handleLoadMore = () => {
    if (merchandiseList?.length) {
      productsApi
        .getListProducts(
          {
            type: tabSelect,
            sort: sortItem,
            endCursor: endCursor,
            endFeatured: endFeatured,
            filter: handleFormatItemFilter(filterItem),
          },
          handleConvertToLocaleContentful(locale as string)
        )
        .then((res: any) => {
          if (res.status !== 200) {
            throw res;
          }
          handleSetData(res, 'add');
        })
        .catch(() => {});
    }
  };

  const handleChangeSelectTab = (v: any, callback?: () => void) => {
    dispatch(setTabSelect(v));
    refTimeOut.current = setTimeout(() => {
      dispatch(setMerChandiseData([]));
      setHasNextPage(true);
    }, 300);
    setIsEmptyData(false);
    dispatch(setEndFeatured(false));
    callback?.();
    const newFilter = handleFormatItemFilter(filterItem);

    productsApi
      .getListProducts(
        {
          type: v,
          sort: sortItem,
          filter: newFilter,
        },
        handleConvertToLocaleContentful(locale as string)
      )
      .then((res: any) => {
        if (res.status !== 200) {
          throw res;
        }
        if (!refCallApi.current) {
          return;
        }
        handleSetData(res);
      })
      .catch(() => {});
  };

  const handleFilter = (filter: any, sort: any, callback?: () => void) => {
    setFirstLoad(false);
    setIsEmptyData(false);
    dispatch(setMerChandiseData([]));
    setHasNextPage(true);
    dispatch(setEndFeatured(false));
    dispatch(setSortItem(sort));
    callback?.();
    const newFilter = handleFormatItemFilter(filter);
    dispatch(setFilterItem(filter));

    productsApi
      .getListProducts(
        {
          type: tabSelect,
          sort: sort || 'NEWEST',
          filter: newFilter,
        },
        handleConvertToLocaleContentful(locale as string)
      )
      .then((res: any) => {
        if (res.status !== 200) {
          throw res;
        }
        if (!refCallApi.current) {
          return;
        }
        handleSetData(res);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (tab) {
      dispatch(setTabSelect(tab));
    }
  }, [tab]);

  //get init productList
  useEffect(() => {
    if (!Object.keys(dataTranslation)?.length || !!merchandiseList.length) {
      return;
    }
    if (firstLoad && refFirstDispatch.current) {
      const newFilterItem = {
        genre: [...(filterItem?.genre || [])],
        price: filterItem?.price || [],
      };

      if (refTimeOutFirstLoad.current) {
        window.clearTimeout(refTimeOutFirstLoad.current);
      }

      refTimeOutFirstLoad.current = setTimeout(() => {
        refTimeOutFirstLoad.current = undefined;
        productsApi
          .getListProducts(
            {
              type: tabSelect,
              sort: sortItem,
              endCursor: endCursor,
              filter: handleFormatItemFilter(newFilterItem),
            },
            handleConvertToLocaleContentful(locale as string)
          )
          .then((res: any) => {
            if (res.status !== 200) {
              throw res;
            }
            handleSetData(res);
            refFirstDispatch.current = false;
            setFirstLoad(false);
          })
          .catch(() => {
            setFirstLoad(false);
          })
          .finally(() => {
            dispatch(setFilterItem(newFilterItem));
            refFirstDispatch.current = false;
          });
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterItem, firstLoad, dataTranslation, tabSelect]);

  const SeoStandard = seo?.merchandise
    ? {
        __typename: 'SeoStandard',
        ...seo.merchandise,
      }
    : null;

  return (
    <>
      {SeoStandard && <BlockRenderer block={[SeoStandard]} />}
      <Container
        sx={{
          paddingTop: {
            xs: '72px',
            md: '80px',
          },
          paddingBottom: '40px',
        }}
      >
        <EStoreMerchandiseOrganisms
          hasNextPage={hasNextPage}
          onLoadMore={handleLoadMore}
          onlSelectTab={handleChangeSelectTab}
          onFilter={handleFilter}
          typeTabFilter={TypeTabFilter}
          isEmptyData={isEmptyData}
          productList={merchandiseList}
        />
      </Container>
    </>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

  const promises: [
    ReturnType<typeof getPageData>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>,
    ReturnType<typeof getGloablByType>
  ] = [
    getPageData({slug: 'store', preview}, ctx),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.StoreTab),
    getGloablByType(handleConvertToLocaleContentful(ctx.locale as string), GLOBAL_TYPE.SEO),
    getGloablByType(
      handleConvertToLocaleContentful(ctx.locale as string),
      GLOBAL_TYPE.FilterPriceProducts
    ),
    getGloablByType(
      handleConvertToLocaleContentful(ctx.locale as string),
      GLOBAL_TYPE.SortByProducts
    ),
  ];
  const [pageData, tabList, seo, filterPrice, sortBy] = await Promise.all(promises);
  const {data} = pageData;
  return {
    props: {
      data,
      seo,
      filterPrice,
      sortBy,
      tabList: tabList?.merchandise_listing || [],
    },
    revalidate: 60,
  };
};

export default Merchandise;
